export default __webpack_public_path__ + "static/media/partners_banner.52f1bb9e.jpg";